// Runtime configuration for the patient web app.
//
// Every environment-specific value is read here and nowhere else, so there is
// one place to check when a build points at the wrong host.
//
// The values themselves come from the checked-in per-environment manifest
// (./environments.json, selected by REACT_APP_ENV — see `.env.example`), not
// from the deploy workflows. Individual `REACT_APP_*` variables still override
// their manifest entry, which is how the compose stack points local dev at
// container hostnames. Only variables prefixed `REACT_APP_` are baked into the
// bundle by CRA; an unprefixed name silently resolves to `undefined`.
//
// Values identical in every environment are plain constants below, not env
// vars and not manifest entries.
import environment, { envName } from "./environment";
import { GOOGLE_API_KEY, OVERRIDES } from "./env";

/** Debounce for search-as-you-type inputs, in ms. Not environment-specific. */
const DEBOUNCE_TIMEOUT_MS = 2000;

/**
 * Ceiling on every HTTP request, in ms. Axios defaults to NO timeout, so before
 * this existed a stalled connection — most likely the external ABDM gateway —
 * left the awaiting screen spinning forever with no failure ever surfaced.
 * 30 s is deliberately generous: the ABDM gateway is the slowest dependency and
 * some of its calls legitimately take double-digit seconds.
 */
const REQUEST_TIMEOUT_MS = 30000;

const config = {
  envName,
  google: { apiKey: GOOGLE_API_KEY },
  backend: {
    baseUrl: OVERRIDES.backendUrl || environment.backendUrl,
  },
  abdm: {
    baseUrl: OVERRIDES.abdmUrl || environment.abdmUrl,
  },
  // Origin the service worker is registered under (src/serviceWorkerRegistration.js).
  publicUrl: OVERRIDES.publicUrl || environment.publicUrl,
  // Non-secret CloudWatch RUM stack outputs; null where no monitor is provisioned.
  rum: environment.rum,
  debounceTimeout: DEBOUNCE_TIMEOUT_MS,
  requestTimeout: REQUEST_TIMEOUT_MS,
};

export default config;
